module.exports = __webpack_public_path__ + "images/icons/logos/brand-black-5e540068.svg";